/* global Swiper */

class UpsellSlider extends HTMLElement {
  connectedCallback() {
    this._init();
  }

  _init() {
    const swiperEl = this.querySelector('.upsell-swiper');
    if (!swiperEl || swiperEl.swiper) return;

    new Swiper(swiperEl, {
      slidesPerView: 2.6,
      spaceBetween: 8,
      slidesOffsetBefore: 16,
      slidesOffsetAfter: 16,
      navigation: {
        prevEl: this.querySelector('.upsell-swiper-prev'),
        nextEl: this.querySelector('.upsell-swiper-next'),
      },
    });
  }
}

customElements.define('upsell-slider', UpsellSlider);
